<app-navbar></app-navbar>
<div (click)="containerClick($event)"
     id="container"
     #container
     class="study-page"
     tabindex="0"
     autofocus
     (keydown.arrowRight)="nextQuestion($event)"
     (keydown.arrowLeft)="prevQuestion($event)">
  <div class="study-layout">
    <div class="study-main">
      <!-- Question panel -->
      <div class="panel study-question-panel">
        <!-- Flag and Hide Buttons -->
        <div class="study-flag-row">
          <button 
            type="button" 
            class="study-flag-btn study-flag-red-btn"
            [class.study-flag-active]="currentFlagId === 1"
            (click)="$event.stopPropagation(); setFlag(1)"
            title="Red Flag">
            <i class="bi bi-flag-fill study-flag-icon"></i>
          </button>
          <button 
            type="button" 
            class="study-flag-btn study-flag-yellow-btn"
            [class.study-flag-active]="currentFlagId === 3"
            (click)="$event.stopPropagation(); setFlag(3)"
            title="Yellow Flag">
            <i class="bi bi-flag-fill study-flag-icon"></i>
          </button>
          <button 
            type="button" 
            class="study-flag-btn study-flag-green-btn"
            [class.study-flag-active]="currentFlagId === 2"
            (click)="$event.stopPropagation(); setFlag(2)"
            title="Green Flag">
            <i class="bi bi-flag-fill study-flag-icon"></i>
          </button>
          <button 
            type="button" 
            class="study-flag-btn study-flag-clear"
            [class.study-flag-active]="currentFlagId === null"
            (click)="$event.stopPropagation(); setFlag(null)"
            title="No flag">
            <i class="bi bi-flag study-flag-icon"></i>
          </button>
          <button 
            type="button" 
            class="study-flag-btn study-flag-hide"
            [class.study-flag-active]="currentHide === 1"
            (click)="$event.stopPropagation(); toggleHide()"
            title="Hide in next test">
            <i class="bi bi-eye-slash-fill"></i>
          </button>
          <button
            type="button"
            class="study-flag-btn study-flight-comp-btn"
            (click)="openFlightComputer($event)"
            title="E6B flight computer">
            <i class="bi bi-compass"></i>
            <span class="study-e6b-label">E6B</span>
          </button>
        </div>

        <!-- Tabs Navigation -->
        <ul class="study-tabs" role="tablist">
          <li role="presentation">
            <button class="study-tab" [class.study-tab-active]="activeTab === 'question'" (click)="selectTab('question')" type="button">
              Question
            </button>
          </li>
          <li role="presentation">
            <button class="study-tab" [class.study-tab-active]="activeTab === 'explanation'" (click)="selectTab('explanation')" type="button">
              Explanation
            </button>
          </li>
          <li role="presentation">
            <button class="study-tab" [class.study-tab-active]="activeTab === 'note'" [class.study-tab-has-note]="hasNote" (click)="selectTab('note')" type="button">
              Note @if (hasNote) { <span class="study-tab-badge">!</span> }
            </button>
          </li>
          <li role="presentation">
            <button class="study-tab" [class.study-tab-active]="activeTab === 'exam'" (click)="selectTab('exam')" type="button">
              Exam Question
            </button>
          </li>
          <li role="presentation">
            <button class="study-tab" [class.study-tab-active]="activeTab === 'comments'" (click)="selectTab('comments')" type="button">
              Comments
            </button>
          </li>
        </ul>

        <!-- Tab Content -->
        <!-- Question Tab -->
        @if (activeTab === 'question') {
        <div class="study-tab-content">
        <app-question-pool-question-detail
          [questionId]="questionId"
          [examMode]="false"
          [examTimeLeft]="1"
          [shuffleQuestionAnswers]="userTestSettings?.shuffleQuestionAnswers ?? false"
          [nextAutomatically]="userTestSettings?.nextAutomatically ?? false">
        </app-question-pool-question-detail>
        </div>
        }

        <!-- Explanation Tab -->
        @if (activeTab === 'explanation') {
        <div class="study-tab-content">
        <div class="study-tab-body">
        <div *ngIf="isLoadingExplanation" class="text-center py-4">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div *ngIf="!isLoadingExplanation && explanationData">
          <div *ngIf="explanationData.hasE6bExplanation" class="e6b-play-cta mb-4">
            <button type="button" class="e6b-play-btn" (click)="openE6bPlayer()">
              <span class="e6b-play-thumb" aria-hidden="true">
                <img src="/flight-computer/wind-high.svg" alt="" />
                <span class="e6b-play-icon">▶</span>
              </span>
              <span class="e6b-play-copy">
                <strong>Play on E6B</strong>
                <small>{{ explanationData.e6bTitle || 'Step-through on the flight computer' }}</small>
              </span>
            </button>
          </div>
          <div *ngIf="explanationData.explanationHtml || (explanationData.explanationImageUrls && explanationData.explanationImageUrls.length > 0)">
            <div *ngIf="explanationData.explanationHtml" class="mb-4">
              <h5>Explanation</h5>
              <div class="explanation-html" [innerHTML]="explanationData.explanationHtml"></div>
            </div>
            <div *ngFor="let url of explanationData.explanationImageUrls || (explanationData.figureExplanation ? [explanationData.figureExplanation] : [])" class="mb-4">
              <img [src]="url" alt="Explanation figure" class="img-fluid clickable-image" (click)="openImageOverlay(url)" />
            </div>
          </div>
          <div *ngIf="!explanationData.hasE6bExplanation && !explanationData.explanationHtml && (!explanationData.explanationImageUrls || explanationData.explanationImageUrls.length === 0) && !explanationData.figureExplanation" class="study-explanation-empty text-muted">
            <p>No explanation available for this question.</p>
            <p><em>Note: If you have additional information about this question, you can add it in the Notes or publicly in the Comments tab.</em></p>
          </div>
        </div>
        </div>
        </div>
        }

        <!-- Note Tab -->
        @if (activeTab === 'note') {
        <div class="study-tab-content">
        <div class="study-tab-body">
        <div class="mb-3">
          <h5>Your Notes</h5>
          <small class="form-text text-muted d-block mb-2">Add personal notes for this question. Notes are saved automatically.</small>
          <textarea 
            class="form-control" 
            id="questionNotes" 
            rows="10" 
            [(ngModel)]="questionNotes" 
            (input)="onNotesInput()"
            (click)="$event.stopPropagation()"
            (focus)="$event.stopPropagation()"
            [ngModelOptions]="{standalone: true}"
            placeholder="Enter your notes here..."></textarea>
        </div>
        </div>
        </div>
        }

        <!-- Exam Question Tab -->
        @if (activeTab === 'exam') {
        <div class="study-tab-content">
        <div class="study-tab-body">
        <div *ngIf="isLoadingExamState" class="text-center py-4">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div *ngIf="!isLoadingExamState">
          <h5>Official Exam Usage</h5>
          <div *ngIf="examStateData && examStateData.length > 0">
            <p class="text-muted mb-3">This question has been reported as used in the following official state exams:</p>
            <div class="list-group">
              <div *ngFor="let exam of examStateData" class="list-group-item">
                <div class="d-flex justify-content-between">
                  <strong>{{ exam.country }}</strong>
                  <span class="text-muted">{{ exam.date }}</span>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="!examStateData || examStateData.length === 0" class="text-muted">
            <p>This question has not been reported in any official state exams.</p>
          </div>
        </div>
        </div>
        </div>
        }

        <!-- Comments Tab -->
        @if (activeTab === 'comments') {
        <div class="study-tab-content">
        <div class="study-tab-body">
        <div *ngIf="isLoadingComments" class="text-center py-4">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div *ngIf="!isLoadingComments">
          <p class="text-muted mb-3">Comments from other users about this question:</p>
          <div *ngIf="commentsData && commentsData.length > 0" class="comments-container mb-4">
            <div *ngFor="let comment of commentsData; let i = index" class="comment-item" [ngClass]="{'comment-left': i % 2 === 0, 'comment-right': i % 2 === 1}">
              <div class="comment-content">
                <div class="comment-header">
                  <strong>{{ comment.username }}</strong>
                  <small class="text-muted">{{ formatDate(comment.createdAt) }}</small>
                </div>
                <div class="comment-text">{{ comment.comment }}</div>
              </div>
            </div>
          </div>
          <div *ngIf="!commentsData || commentsData.length === 0" class="text-muted mb-4">
            <p>No comments yet. Be the first to comment!</p>
          </div>
          
          <!-- Comment Submission Form -->
          <div class="mt-5">
            <h6>Add a Comment</h6>
            <p class="text-muted small mb-3">
              <em>Please share comments that are of interest to the community, such as clarifications, additional context, or helpful insights about this question.</em>
            </p>
            <div class="mb-3">
              <textarea 
                class="form-control" 
                id="newComment" 
                rows="4" 
                [(ngModel)]="newComment"
                (click)="$event.stopPropagation()"
                (focus)="$event.stopPropagation()"
                [ngModelOptions]="{standalone: true}"
                [disabled]="!canSubmitComment"
                placeholder="Enter your comment here..."></textarea>
              <div *ngIf="!canSubmitComment && commentsData && commentsData.length > 0" class="text-warning small mt-2">
                You cannot submit another comment until someone else has commented.
              </div>
            </div>
            <div class="d-flex justify-content-end">
              <button 
                class="btn btn-primary" 
                (click)="submitComment()" 
                [disabled]="!newComment || newComment.trim().length === 0 || isSubmittingComment || !canSubmitComment">
                <span *ngIf="isSubmittingComment" class="spinner-border spinner-border-sm me-2"></span>
                Submit Comment
              </button>
            </div>
          </div>
        </div>
        </div>
        </div>
        }
      </div>
    </div>

    <!-- RHS buttons panel -->
    <aside class="panel study-rhs-panel">
      <h4 class="study-rhs-title">Study</h4>
      <div class="study-rhs-actions">
        <button (click)="cancelTest()" class="study-btn study-btn-cancel">Cancel</button>
        <button (click)="requestFinish()" class="study-btn study-btn-finish">Finish Test</button>
      </div>

      <div class="study-question-grid" [class.study-question-grid-paginated]="usePaginatedGrid">
        @for (id of getVisibleQuestionIds(); track id) {
          <a class="study-q-btn"
             [routerLink]="['/question-pool-study/', id+'']"
             [class.study-q-active]="questionsMap[id]?.id === (questionId || 1)"
             [class.study-q-unanswered]="questionsMap[id]?.answered === false"
             [class.study-q-wrong]="questionsMap[id]?.answered === true && questionsMap[id]?.correctAnswer === false"
             [class.study-q-correct]="questionsMap[id]?.answered === true && questionsMap[id]?.correctAnswer === true">
            {{ getQuestionNumber(id) }}
          </a>
        }
      </div>

      @if (usePaginatedGrid) {
      <nav class="study-pagination" aria-label="Question grid pagination">
        <button type="button" class="study-pagination-btn" (click)="goToPage(1)" [disabled]="questionGridPage <= 1" title="First page">««</button>
        <button type="button" class="study-pagination-btn" (click)="goToPage(questionGridPage - 1)" [disabled]="questionGridPage <= 1" title="Previous page">«</button>
        @for (p of getPageNumbers(); track p) {
          <button type="button" class="study-pagination-btn" [class.study-pagination-active]="p === questionGridPage" (click)="goToPage(p)">{{ p }}</button>
        }
        <button type="button" class="study-pagination-btn" (click)="goToPage(questionGridPage + 1)" [disabled]="questionGridPage >= getTotalPages()" title="Next page">»</button>
        <button type="button" class="study-pagination-btn" (click)="goToPage(getTotalPages())" [disabled]="questionGridPage >= getTotalPages()" title="Last page">»»</button>
      </nav>
      }

      <button (click)="showShortcuts()" class="study-btn study-btn-shortcuts" title="Keyboard shortcuts">
        <i class="bi bi-keyboard"></i> Shortcuts
      </button>
    </aside>
  </div>

  <!-- Mobile bottom test bar — hidden on desktop via CSS. Cancel and Finish
       stay reachable without scrolling past the question, plus prev/next
       arrows and a counter that opens the full grid as a bottom sheet. -->
  <nav class="mobile-test-bar" aria-label="Test navigation">
    <button type="button" class="mobile-test-btn mobile-test-btn-cancel" (click)="requestCancelFromMobile()" aria-label="Cancel test">
      <i class="bi bi-x-lg"></i>
    </button>
    <button type="button" class="mobile-test-btn mobile-test-btn-arrow" (click)="prevQuestion()" aria-label="Previous question">
      <i class="bi bi-chevron-left"></i>
    </button>
    <button type="button" class="mobile-test-btn mobile-test-btn-counter" (click)="toggleGridSheet()" [attr.aria-expanded]="gridSheetOpen" aria-haspopup="dialog">
      <span>Q {{ getQuestionNumber(questionId) }} / {{ getTotalQuestions() }}</span>
      <i class="bi bi-grid-3x3-gap"></i>
    </button>
    <button type="button" class="mobile-test-btn mobile-test-btn-arrow" (click)="nextQuestion()" aria-label="Next question">
      <i class="bi bi-chevron-right"></i>
    </button>
    <button type="button" class="mobile-test-btn mobile-test-btn-finish" (click)="requestFinish()" aria-label="Finish test">
      <i class="bi bi-check2-circle"></i>
    </button>
  </nav>

  @if (gridSheetOpen) {
    <div class="grid-sheet-backdrop" (click)="closeGridSheet()" (keydown)="$event.key === 'Escape' && closeGridSheet()" role="button" tabindex="0" aria-label="Close question list"></div>
    <div class="grid-sheet" role="dialog" aria-label="Question list">
      <div class="grid-sheet-header">
        <h3 class="grid-sheet-title">Questions</h3>
        <button type="button" class="grid-sheet-close" (click)="closeGridSheet()" aria-label="Close">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
      <div class="grid-sheet-body">
        <div class="study-question-grid" [class.study-question-grid-paginated]="usePaginatedGrid">
          @for (id of getVisibleQuestionIds(); track id) {
            <a class="study-q-btn"
               (click)="closeGridSheet()"
               [routerLink]="['/question-pool-study/', id+'']"
               [class.study-q-active]="questionsMap[id]?.id === (questionId || 1)"
               [class.study-q-unanswered]="questionsMap[id]?.answered === false"
               [class.study-q-wrong]="questionsMap[id]?.answered === true && questionsMap[id]?.correctAnswer === false"
               [class.study-q-correct]="questionsMap[id]?.answered === true && questionsMap[id]?.correctAnswer === true">
              {{ getQuestionNumber(id) }}
            </a>
          }
        </div>
        @if (usePaginatedGrid) {
          <nav class="study-pagination" aria-label="Question grid pagination">
            <button type="button" class="study-pagination-btn" (click)="goToPage(1)" [disabled]="questionGridPage <= 1" title="First page">««</button>
            <button type="button" class="study-pagination-btn" (click)="goToPage(questionGridPage - 1)" [disabled]="questionGridPage <= 1" title="Previous page">«</button>
            @for (p of getPageNumbers(); track p) {
              <button type="button" class="study-pagination-btn" [class.study-pagination-active]="p === questionGridPage" (click)="goToPage(p)">{{ p }}</button>
            }
            <button type="button" class="study-pagination-btn" (click)="goToPage(questionGridPage + 1)" [disabled]="questionGridPage >= getTotalPages()" title="Next page">»</button>
            <button type="button" class="study-pagination-btn" (click)="goToPage(getTotalPages())" [disabled]="questionGridPage >= getTotalPages()" title="Last page">»»</button>
          </nav>
        }
      </div>
    </div>
  }
</div>

<!-- Cancel Confirmation Modal -->
<div *ngIf="showCancelConfirm" class="modal-overlay" (click)="continueTest()">
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Cancel Test?</h5>
        <button type="button" class="btn-close" (click)="continueTest()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        @if (hasAnsweredQuestions()) {
          <p>You have answered some questions. What would you like to do?</p>
        } @else {
          <p>Cancel this test and return to the question pool?</p>
        }
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-danger" (click)="cancelWithoutSaving()">Cancel without Saving</button>
        @if (hasAnsweredQuestions()) {
          <button type="button" class="btn btn-outline-warning" (click)="cancelToResumeLater()">Cancel to Resume Later</button>
        }
        <button type="button" class="btn btn-primary" (click)="continueTest()">Continue</button>
      </div>
    </div>
  </div>
</div>

<!-- Finish Confirmation Modal — only shown when the test has unanswered
     questions. Fully-answered tests finish silently. -->
<div *ngIf="showFinishConfirm" class="modal-overlay" (click)="cancelFinish()">
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Finish Test?</h5>
        <button type="button" class="btn-close" (click)="cancelFinish()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p class="mb-0">
          You have <strong>{{ finishUnansweredCount }}</strong>
          @if (finishUnansweredCount === 1) { unanswered question. } @else { unanswered questions. }
          Finish the test now and view the report, or go back and answer the rest?
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-success" (click)="confirmFinish()">
          <i class="bi bi-check2-circle"></i> Finish Test
        </button>
        <button type="button" class="btn btn-primary" (click)="cancelFinish()">Continue Test</button>
      </div>
    </div>
  </div>
</div>

<!-- Leave page confirmation (navigation away, back, link) -->
<div *ngIf="showLeaveConfirm" class="modal-overlay" (click)="confirmLeavePage(false)">
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Leave study?</h5>
        <button type="button" class="btn-close" (click)="confirmLeavePage(false)" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p class="mb-0">Are you sure you want to leave without saving? You can keep your current state using the Cancel button.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" #leaveModalStayBtn (click)="confirmLeavePage(false)">Stay</button>
        <button type="button" class="btn btn-outline-secondary" (click)="confirmLeavePage(true)">Leave</button>
      </div>
    </div>
  </div>
</div>

<!-- Comment Confirmation Modal -->
<div *ngIf="showCommentConfirm" class="modal-overlay" (click)="cancelComment()">
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Submit Public Comment?</h5>
        <button type="button" class="btn-close" (click)="cancelComment()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>Are you sure you want to submit this comment publicly? Your comment will be visible to all users.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="cancelComment()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="confirmComment()">Submit Comment</button>
      </div>
    </div>
  </div>
</div>

<!-- Image overlay: click explanation image to view full size -->
<div *ngIf="imageOverlayUrl" class="image-overlay" (click)="closeImageOverlay()">
  <img [src]="imageOverlayUrl" alt="Full size" class="image-overlay-img" (click)="$event.stopPropagation()" />
</div>

<!-- Shortcuts Modal -->
<div *ngIf="showShortcutsModal" class="modal-overlay" (click)="closeShortcuts()">
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Keyboard Shortcuts</h5>
        <button type="button" class="btn-close" (click)="closeShortcuts()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p><strong>Navigation:</strong></p>
        <ul>
          <li><kbd>←</kbd> (Left Arrow) - Previous question</li>
          <li><kbd>→</kbd> (Right Arrow) - Next question</li>
        </ul>
        <p><strong>Tools:</strong></p>
        <ul>
          <li><kbd>E</kbd> - Open E6B flight computer</li>
        </ul>
        <p><strong>Mark Answer:</strong></p>
        <ul>
          <li><kbd>1</kbd> - Select 1st answer (top)</li>
          <li><kbd>2</kbd> - Select 2nd answer</li>
          <li><kbd>3</kbd> - Select 3rd answer</li>
          <li><kbd>4</kbd> - Select 4th answer (bottom)</li>
        </ul>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="closeShortcuts()">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Flight computer overlay (interactive or playback) -->
@if (showFlightComputer) {
  <div class="modal-overlay flight-computer-overlay" (click)="closeFlightComputer()">
    <div class="flight-computer-dialog" (click)="$event.stopPropagation()">
      <app-flight-computer
        [uiMode]="flightComputerUiMode"
        [instructions]="flightComputerInstructions"
        [autoplay]="flightComputerUiMode === 'playback'"
        (closed)="closeFlightComputer()"
      />
    </div>
  </div>
}
